<thead class="esf-table__head">
  <tr class="esf-table__row" [ngClass]="{'small-table-text': smallTable}">
    <th class="esf-table__cell esf-table__cell--head esf-table__cell--shrink esf-table__cell--checkbox" style="width: .1%;" *ngIf="selectableTable">
      <span class="esf-table__cell--head-inner">
        <div class="esf-check-radio esf-check-radio--check-all" [class.-partial-selection]="checkSelected() === 'partial'">
          <input class="esf-check-radio__input esf-check-radio--check__input esf-table-check-all"
                 type="checkbox"
                 id="table-check-all-2"
                 [checked]="checkSelected() === 'all'"
                 (click)="setAllSelected()">
          <label class="esf-check-radio__label esf-check-radio--check__label" for="table-check-all-2"></label>
        </div>
      </span>
    </th>
    <th class="esf-table__cell esf-table__cell--head" *ngFor="let col of columns" [attr.data-label]="col">
      <span class="esf-table__cell-inner">{{ col }}</span>
    </th>
    <th class="esf-table__cell esf-table__cell--head esf-table__cell--no-label" *ngIf="actionButtons.length"></th>
  </tr>
</thead>
<tbody class="esf-table__body">

  <ng-container [ngSwitch]="limitResults">
    <ng-container *ngSwitchCase="null">
      <tr app-table-row
          *ngFor="let element of data; let i = index"
          class="esf-table__row esf-table__row--is-clickable"
          [class.esf-table__row--checkbox]="selectableTable"
          [class.esf-table__row--is-clickable]="rowClickEvent.observed"
          [actionButtons]="actionButtons"
          [smallTable]="smallTable"
          [rowData]="element"
          [keys]="keys"
          [columns]="columns"
          (rowButtonClickEvent)="rowButtonClick($event)"
          (click)="rowClicked(element)">

        <td class="esf-table__cell esf-table__cell--shrink esf-table__cell--checkbox" *ngIf="selectableTable">
          <span class="esf-table__cell--inner">
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--check__input"
                     type="checkbox"
                     [id]="element.id"
                     [checked]="element.selected"
                     (click)="rowClicked(element)">
              <label class="esf-check-radio__label esf-check-radio--check__label" [for]="element.id"></label>
            </div>
          </span>
        </td>
      </tr>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <tr app-table-row
          *ngFor="let element of data | slice:0:limitResults; let i = index"
          class="esf-table__row esf-table__row--is-clickable"
          [class.esf-table__row--checkbox]="selectableTable"
          [actionButtons]="actionButtons"
          [smallTable]="smallTable"
          [rowData]="element"
          [keys]="keys"
          [columns]="columns"
          (rowButtonClickEvent)="rowButtonClick($event)"
          (click)="rowClicked(element)">

        <td class="esf-table__cell esf-table__cell--shrink esf-table__cell--checkbox" *ngIf="selectableTable">
          <span class="esf-table__cell--inner">
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--check__input"
                     type="checkbox"
                     [id]="element.id"
                     [checked]="element.selected"
                     (click)="rowClicked(element)">
              <label class="esf-check-radio__label esf-check-radio--check__label" [for]="element.id"></label>
            </div>
          </span>
        </td>
      </tr>
    </ng-container>
  </ng-container>


</tbody>
